import * as api from '../api.js';

// Exit/switch-out events are often fired during page unload or tab hide; the request
// is frequently aborted by the browser, causing unhandled rejections and Rollbar noise.
// We catch and ignore failures for these types so they don't surface as errors.
const UNLOAD_EVENT_TYPES = new Set(['exit', 'switch-out']);

export const putEvent = async ({ type, data }, set, get) => {
  if (process.env.REACT_APP_ENV === 'dev') {
    return;
  }
  const outingId = get().outing?._id;
  const sessionId = get().sessionInfo?.id;
  try {
    const { success, failure } = await api.putEvent({
      type,
      sessionId,
      data: {
        ...data,
        outingId,
      },
    });
    if (failure) {
      // Logged for other types if we ever want to handle failure
    }
  } catch (err) {
    if (UNLOAD_EVENT_TYPES.has(type)) {
      // Expected when page unloads or tab is hidden; ignore to avoid Rollbar noise
      return;
    }
    throw err;
  }
};
